import React, { Component } from 'react';
import { Form, Button } from 'reactstrap';
import FormInput2 from './formInput';
import MatrixTable from './maxtrixTable';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import swal from 'sweetalert2';
import storeDataFunc from './dropdownStore';


class DynamicForm2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.data,
            bottomTable: this.props.bottomTable !== undefined ? this.props.bottomTable : { type: 'ADD', data: [], attributeList: [] },
            submitted: false,
            formIsValid: false,
            showSwal: true,
            loading: false,
            error: false,
            text: [],
            checkedItems: new Map(),
            metrixData: {},
            disableButtonCredit: true,
            paragraphText: '',
            emailBroke: ''
        };
    }

    componentDidMount() {
        if (this.props.checkboxModal !== '') {
            let dataCheckbox = this.props.checkboxModal.data;
            let checkedData = []

            this.props.checkboxKey !== null &&
                this.props.checkboxKey !== '' ?
                dataCheckbox = this.props.checkboxModal.data
                :
                dataCheckbox = this.state.formData


            dataCheckbox.map(val => {
                this.state.formData[this.props.checkboxKey].map(value => {
                    if (val.relation_group_id === value.id) {
                        checkedData.push(val)
                    }
                })
            })

            checkedData.map(val => {
                const item = `modal${val.relation_group_id}`
                let isChecked = true;
                this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }))
            })
        }
    }

    handleChange = (e, data) => {

        const item = e.target.name;
        const isChecked = e.target.checked;
        this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }), () => {

        })
    }

    isValidHandler = (updatedValue, validation, regexText, updatedElement) => {
        let isValid = true;
        let regex = new RegExp(regexText);
    
        if (validation.required) {
            if (updatedElement.type === 'multiSelect') {
                isValid = updatedValue.length > 0;
            } else {
                if (regex.test(updatedValue)) {
                    isValid = updatedValue.trim() !== '' && isValid;
                } else if (!regex.test(updatedValue)) {
                    isValid = false;
                }
    
                if (updatedValue === 'Choose an Option...') {
                    isValid = false;
                }
            }
        }
    
        if (updatedElement.type === 'pincodeText') {
            if (updatedValue === '') {
                if (validation.required === false) {
                    isValid = true;
                } else {
                    if (regex.test(updatedValue)) {
                        isValid = updatedValue.trim() !== '' && isValid;
                    } else if (!regex.test(updatedValue)) {
                        isValid = false;
                        validation.message = 'Pincode should be a Number with 6digits';
                    }
                }
            } else {
                if (regex.test(updatedValue)) {
                    isValid = updatedValue.trim() !== '' && isValid;
                } else if (!regex.test(updatedValue)) {
                    isValid = false;
                    validation.message = 'Pincode should be a Number with 6digits';
                }
            }
        }
    
        if (validation.min || validation.max) {
            isValid = (updatedValue.trim().length === validation.min || updatedValue.trim().length === 0) && isValid;
        }
    
        return isValid;
    };


    isFieldValidHandler = (updatedValue, validation, fieldName) => {

        let isValid = true;

        if (
            fieldName == "full_name" ||
            fieldName == "short_name" ||
            fieldName == "city" ||
            fieldName == "state" || fieldName == "pincode" || fieldName == "email" || fieldName == "organisation_name" || fieldName == 'credits' && validation && validation.required) {
            let regex = new RegExp(validation.required);
            isValid = regex.test(updatedValue);
        }

        return isValid;
    }

    handleSubmit = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
    
        if (this.props.checkboxModal === '') {
            const formData = {};
            const updatedData = [...this.state.formData];
            this.setState({
                submitted: true
            });
    
            let formIsValid = true;
            for (let identifiers in updatedData) {
                const element = updatedData[identifiers];
                if (element.valid !== undefined) {
                    if (element.type === 'multiSelect') {
                        element.valid = element.value.length > 0;
                    }
                    if (element.is_email && element.commaSepareted) {
                        formIsValid = element.valid && formIsValid;
                    } else {
                        formIsValid = element.valid && formIsValid;
                    }
                }
            }
    
            const sellerData = {};
    
            if (formIsValid) {
                this.state.formData.forEach(function (element) {
                    if (sellerData.country !== undefined) {
                        if (isNaN(sellerData.country)) {
                            sellerData.country = '';
                        }
                    }
    
                    sellerData[element.key] = element.value;
                });
    
                this.setState({
                    loading: true,
                    error: false,
                }, () => {
                    this.props.action(sellerData);
                    dispatch({
                        type: 'START_MODAL'
                    });
                });
    
                updatedData.forEach(val => {
                    val.value = '';
                });
    
                this.setState({
                    submitted: false,
                    formData: updatedData
                });
            }
        } else if (this.props.checkboxModal !== '') {
            let arrChecked = [];
            let dataCheckbox;
    
            if (this.props.checkboxKey !== null && this.props.checkboxKey !== '') {
                dataCheckbox = this.state.formData[this.props.checkboxKey];
            } else {
                dataCheckbox = this.state.formData;
            }
    
            for (let [key, value] of this.state.checkedItems) {
                dataCheckbox.forEach(val => {
                    if (key === `modal${val.id}`) {
                        if (value === true) {
                            let extractModal = key.replace('modal', '');
    
                            arrChecked.push({
                                name: val[this.props.checkboxModal.labelKey],
                                id: parseInt(extractModal, 10),
                            });
                        }
                    }
                });
            }
    
            if (arrChecked.length !== 0 || this.state.formData.length === 0) {
                dispatch({
                    type: 'START_MODAL'
                });
                this.props.action(arrChecked);
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.loading !== this.props.loading || prevProps.error !== this.props.error) {
            if (this.props.mainLoading) {
                this.setState({
                    loading: this.props.loading,
                    error: this.props.error,
                    text: this.props.text,
                })
            } else if (!this.props.mainLoading) {
                this.setState({
                    loading: this.props.mainLoading,
                    error: this.props.error,
                    text: this.props.text,
                })
            }
            if (!this.props.loading && !this.props.error) {
                const { dispatch } = this.props;
                dispatch({
                    type: 'INITIAL_IT'
                })


            }
        }

        if (prevProps.text !== this.props.text) {

            if (this.props.text.length !== 0) {
                if (this.props.text.length === 1) {
                    this.closeModal()
                    this.props.text.map(val => {

                        swal({
                            text: val,

                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        })
                    })
                }
            }
        }

        if (prevState.error !== this.state.error) {
            if (this.state.error === true) {
                if (this.state.formdata !== undefined) {
                    this.state.formData.map(val => {
                        val.valid = false
                    })
                }
            }
        }
    }

    closeModal() {


        this.props.backFunc()
    }

    disableButtonFunc(bool) {
        this.setState({
            disableButton: bool
        })
    }

    propsChanged = (event, identifier) => {
        const currentEventVar = event.target;
        const updatedData = [...this.state.formData];
        const updatedElement = { ...updatedData[identifier] };
    
        if (event.target.value !== '___{Invalid}_@_{Date}___') {
            if (updatedElement.elementConfig.name === 'chooseFile') {
                // Handle file upload
                this.props.action(event.target.files[0]);
                this.closeModal();
                return;
            }
            
            if (updatedElement.type === 'multiSelect') {
                updatedElement.value = event.target.value;
                updatedElement.valid = updatedElement.value.length > 0;
            } else {
                updatedElement.value = event.target.value;
                updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, updatedElement.regex, updatedElement);
    
                if (updatedElement.fieldValidation)
                    updatedElement.fieldValid = this.isFieldValidHandler(updatedElement.value, updatedElement.fieldValidation, updatedElement.key);
    
                if (updatedElement.validation.onlyNumbers && !/^\d*$/.test(updatedElement.value)) {
                    updatedElement.valid = false;
                }
            }
    
            updatedData[identifier] = updatedElement;

            this.setState({ formData: updatedData }, () => {
                if (updatedElement.is_email !== undefined) {
                    if (updatedElement.is_email) {
                        updatedElement.value = updatedElement.value.replace(/\s/g, '');
                        if (updatedElement.commaSepareted !== undefined) {
                            if (updatedElement.commaSepareted) {
                                let forwardBackwardCommaRemovedArr = updatedElement.value.split(',');
                                let splitEmailString = forwardBackwardCommaRemovedArr.filter((val, key) => {
                                    if (val !== '') {
                                        return val;
                                    }
                                });
    
                                let counterEmailValidation = 0;
                                let emailBroke = [''];
                                splitEmailString.map((val, key) => {
                                    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                                        counterEmailValidation++;
                                    } else {
                                        if (key !== splitEmailString.length - 1) {
                                            emailBroke.push(val);
                                        }
                                    }
                                });
    
                                this.setState({
                                    emailBroke: emailBroke[1] !== undefined ? emailBroke[1] : ''
                                });
                                if (counterEmailValidation !== splitEmailString.length) {
                                    updatedElement.valid = false;
                                } else {
                                    updatedElement.valid = true;
                                }
                                updatedData[identifier] = updatedElement;
    
                                this.setState({
                                    formData: updatedData
                                });
                            }
                        } else {
                            updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, updatedElement.regex, updatedElement);
                        }
                    }
                }
                if (this.props.creditModal === true) {
                    let goodToGo = true;
                    if (this.state.formData.length === 1) {
                        if (updatedElement.mainType === 'seller') {
                            for (let i = 0; i < this.props.state.credits.credits.length; i++) {
                                const element = this.props.state.credits.credits[i];
    
                                if (element.instrument__id === this.props.rowId) {
                                    if (element.unsold_credits >= updatedElement.value && updatedElement.value > 0) {
                                        goodToGo = false;
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < this.props.state.credits.credits.length; i++) {
                                const element = this.props.state.credits.credits[i];
    
                                if (element.instrument__id === this.props.rowId) {
                                    if (element.unsold_credits >= updatedElement.value && updatedElement.value > 0) {
                                        goodToGo = false;
                                    }
                                }
                            }
                        }
                    }
                    if (updatedElement.key === 'credits') {
                        for (let i = 0; i < this.props.state.credits.credits.length; i++) {
                            const element = this.props.state.credits.credits[i];
                            let instrumentValue = 0;
                            for (let j = 0; j < this.state.formData.length; j++) {
                                const elem = this.state.formData[j];
                                if (elem.key === 'instrument__instrument_name') {
                                    instrumentValue = elem.value;
                                }
                            }
                            if (element.instrument__id == instrumentValue) {
                                if (element.unsold_credits >= updatedElement.value && updatedElement.value > 0) {
                                    goodToGo = false;
                                }
                            }
                        }
                    } else if (updatedElement.key === 'instrument__instrument_name') {
                        for (let i = 0; i < this.props.state.credits.credits.length; i++) {
                            const element = this.props.state.credits.credits[i];
                            let instrumentValue = '0';
    
                            for (let j = 0; j < this.state.formData.length; j++) {
                                const elem = this.state.formData[j];
                                if (elem.key === 'credits') {
                                    instrumentValue = elem.value;
    
                                    if (element.instrument__id == updatedElement.value) {
                                        if (element.unsold_credits >= instrumentValue && instrumentValue.length !== 0 && instrumentValue > 0) {
                                            goodToGo = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.setState({
                        disableButtonCredit: goodToGo
                    });
                }
                if (this.props.bottomTable !== undefined) {
                    if (this.props.bottomTable.type === 'MATRIX_FORM') {
                        if (updatedElement.key === 'competency_pre_fill') {
                            if (updatedElement.value !== 'Choose an Option...') {
                                let data = [];
    
                                const { storeKey } = updatedElement.elementConfig;
    
                                if (this.props.state[storeKey[0]] !== undefined) {
                                    if (this.props.state[storeKey[0]][storeKey[1]] !== undefined) {
                                        if (this.props.state[storeKey[0]][storeKey[1]][storeKey[2]] !== undefined) {
                                            if (this.props.state[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]] !== undefined) {
                                                data = this.props.state[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]];
                                            }
                                        }
                                    }
                                }
    
                                let currentPrefillData = {};
    
                                data.map(val => {
                                    if (val.id == updatedElement.value) {
                                        currentPrefillData = {
                                            ...val
                                        };
                                    }
                                });
    
                                let dataObj = {
                                    ...this.state.bottomTable,
                                    data: {
                                        ...this.state.bottomTable.data,
                                        data: currentPrefillData.competency_values
                                    }
                                };
    
                                let formDataArr = [...this.state.formData];
                                let dataCompType = [];
                                let that = this;
    
                                formDataArr.map(val => {
                                    if (val.key === 'competency_name') {
                                        val.value = currentPrefillData.competency_name;
                                        val.valid = true;
                                    } else if (val.key === 'description') {
                                        val.value = currentPrefillData.description;
                                        val.valid = true;
                                    } else if (val.key === 'top_five_name') {
                                        val.value = currentPrefillData.top_five_name;
                                        val.valid = true;
                                    } else if (val.key === 'competency_type') {
                                        val.elementConfig.storeKey;
                                        dataCompType = [];
    
                                        const storeKeyCompetency = val.elementConfig.storeKey;
    
                                        if (this.props.state[storeKeyCompetency[0]] !== undefined) {
                                            if (this.props.state[storeKeyCompetency[0]][storeKeyCompetency[1]] !== undefined) {
                                                if (this.props.state[storeKeyCompetency[0]][storeKeyCompetency[1]][storeKeyCompetency[2]] !== undefined) {
                                                    if (this.props.state[storeKeyCompetency[0]][storeKeyCompetency[1]][storeKeyCompetency[2]][storeKeyCompetency[3]] !== undefined) {
                                                        dataCompType = this.props.state[storeKeyCompetency[0]][storeKeyCompetency[1]][storeKeyCompetency[2]][storeKeyCompetency[3]];
                                                    }
                                                }
                                            }
                                        }
    
                                        for (let i = 0; i < dataCompType.length; i++) {
                                            const element = dataCompType[i];
                                            if (element.competency_name === currentPrefillData.competency_type__competency_name) {
                                                val.value = element.id;
                                            }
                                        }
                                    }
                                });
    
                                this.setState({
                                    bottomTable: dataObj,
                                    formData: formDataArr
                                });
                            } else {
                                let formDataArr = [...this.state.formData];
    
                                let prevData = this.props.bottomTable.data.editDataState;
    
                                formDataArr.map(val => {
                                    if (this.props.bottomTable.data.type === 'EDIT') {
                                        if (val.key === "competency_type") {
                                            val.value = prevData.competency_type__id;
                                        } else if (val.key === "competency_name") {
                                            val.value = prevData.competency_name;
                                        } else if (val.key === "description") {
                                            val.value = prevData.description;
                                        }
                                    }
                                    else {
                                        val.value = '';
                                    }
                                });
    
                                if (this.props.bottomTable.data.type === 'EDIT') {
                                    let dataObj = {
                                        ...this.state.bottomTable,
                                        data: {
                                            ...this.state.bottomTable.data,
                                            data: this.props.bottomTable.data.metricDataForEdit
                                        }
                                    };
    
                                    this.setState({
                                        bottomTable: dataObj,
                                        formData: formDataArr
                                    });
                                } else {
                                    let dataObj = {
                                        ...this.state.bottomTable,
                                        data: {
                                            ...this.state.bottomTable.data,
                                            data: []
                                        }
                                    };
                                    this.setState({
                                        bottomTable: dataObj,
                                        formData: formDataArr
                                    });
                                }
                            }
                        }
                    }
                }
                if (updatedElement.hasDesc !== undefined) {
                    if (updatedElement.hasDesc) {
                        let paragraphText = '';
    
                        let data = [];
    
                        const { storeKey } = updatedElement.elementConfig;
    
                        data = storeDataFunc(this.props.state, data, storeKey);
    
                        data.map(val => {
                            if (val.id === parseInt(updatedElement.value, 10)) {
                                paragraphText = val.assessor_group__assessor_name_description;
                            }
                        });
    
                        this.setState({
                            paragraphText
                        });
                    }
                }
                if (updatedElement.chooseAnOption) {
                    if (updatedElement.value === "Choose an Option...") {
                        updatedElement.valid = true;
                        updatedData[identifier] = updatedElement;
                        this.setState({
                            formData: updatedData
                        });
                    }
                }
                if (updatedElement.type === "select") {
                    const index = currentEventVar.selectedIndex;
                    const optionElement = currentEventVar.childNodes[index];
                    const option = optionElement.getAttribute('attr-key');
                    if (option === 'ChangeKeyInstrument') {
                        if (optionElement.innerText.includes('(0 credits')) {
                            updatedElement.valid = false;
                            updatedElement.validation.message = 'Credits Should be more than 0';
                            updatedData[identifier] = updatedElement;
                            this.setState({
                                formData: updatedData
                            });
                        } else {
                            updatedElement.validation.message = 'Instrument is required';
                            updatedData[identifier] = updatedElement;
                            this.setState({
                                formData: updatedData
                            });
                        }
                    }
                }
            });
        } else {
            updatedElement.valid = false;
            updatedData[identifier] = updatedElement;
            this.setState({
                formData: updatedData
            });
        }
    };

    resetValue = () => {
        const updatedData = this.state.formData.map(val => {
            val.value = '';
            if (val.validation) {
                if (val.validation.required || val.validation.requiredMain) {
                    val.valid = false;
                }
            }
            return val;
        });

        this.setState({
            formData: updatedData,
            paragraphText: '',
        }, () => {
            this.forceUpdate();
        });
    };


    selectAllChecks = (data) => {

        data.map(item => {
            this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(`modal${item.id}`, true) }), () => {
            })
        })
    }

    deSelectAllChecks = (data) => {
        data.map(item => {
            this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(`modal${item.id}`, false) }), () => {

            })
        })
    }

    getMetrixData = (data) => {

        const { dispatch } = this.props;
        const formData = {};
        const updatedData = Object.assign({}, this.state.formData);

        this.setState({
            submitted: true
        })



        let formIsValid = true;
        for (let identifiers in updatedData) {
            formIsValid = updatedData[identifiers].valid && formIsValid;
        }

        const sellerData = {};


        if (formIsValid) {
            this.state.formData.map(function (element) {
                if (sellerData.country !== undefined) {
                    if (sellerData.country === NaN) {
                        sellerData.country = ''
                    }
                }

                sellerData[element.key] = element.value;
            });


            this.setState({
                loading: true,
                error: false,
            }, () => {
                this.props.action({
                    data,
                    sellerData
                })
                dispatch({
                    type: 'START_MODAL'
                })
            })
            this.state.formData.map(val => {
                val.value = ''
            })

            this.setState({
                submitted: false,
            })
        }
    }

    changeErrorMessage = (identifier, errorMsg) => {
        const updatedData = this.state.formData;

        const updatedElement = updatedData[identifier];

        updatedElement.validation.message = errorMsg;
        updatedData[identifier] = updatedElement

        this.setState({
            formData: updatedData
        })

    }

    commaSeparetedFunc = (identifier, emailArr) => {
        const updatedData = this.state.formData;

        const updatedElement = updatedData[identifier];

        const emailString = emailArr.join(',')

        updatedElement.value = emailString

        if (emailArr.length) {
            updatedElement.valid = true
        } else {
            updatedElement.valid = false
        }

        updatedData[identifier] = updatedElement

        this.setState({
            formData: updatedData
        }, () => {

        })
    }

    render() {
        const { history, dispatch } = this.props;

        let dataCheckbox;


        this.props.checkboxKey !== null &&
            this.props.checkboxKey !== '' ?
            dataCheckbox = this.state.formData[this.props.checkboxKey]
            :
            dataCheckbox = this.state.formData

        const checkboxStyle = this.props.heading === "SET CUSTOM REPORT ACCESS"
            ? {
                display: 'grid',
                gap: '1rem',
                gridTemplateColumns: 'repeat(3, 1fr)',
                marginTop: '20px',
                marginLeft: '10px'
            }
            : {
                display: 'flex',
                flexWrap: 'wrap'
            };




        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', paddingBottom: 10, }}>
                    {
                        this.state.loading &&
                        <div>
                            <i className="fas fa-spinner fa-spin" style={{ color: 'grey' }}></i>
                        </div>
                    }
                    {
                        this.state.error &&
                        <div style={{ textAlign: 'center' }}>
                            <i className="fas fa-exclamation-triangle errorTrigangle"></i>
                            {this.state.text.map((val, key) => {

                                return <p>{val}</p>
                            })}
                        </div>
                    }
                    {
                        (!this.state.loading && !this.props.error) &&

                        this.state.text !== '' &&
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-evenly', width: 300 }}>
                            {/* <i className="fas fa-check"></i> */}
                            <div style={{ display: 'block' }}>

                                {this.state.text.map((val, key) => {

                                    return <p>{val}</p>
                                })}
                            </div>
                        </div>

                    }
                </div>
                {
                    this.state.text.length === 0 ?
                        <Form onSubmit={this.handleSubmit}>
                            {

                                this.props.checkboxModal === '' ?
                                    !this.props.vviSelected &&
                                    <div>

                                        {
                                            this.state.formData.map(
                                                (formElement, id) => {
                                                    if (formElement.type !== 'desc' && formElement.type !== 'multiple_email_error') {

                                                        return (
                                                            <FormInput2
                                                                key={id}
                                                                commaSepareted={formElement.commaSepareted ? formElement.commaSepareted : null}
                                                                type={formElement.type}
                                                                name={formElement.elementConfig.name}
                                                                id={formElement.elementConfig.name}
                                                                placeholder={formElement.elementConfig.placeholder}
                                                                value={formElement.value}
                                                                minValue={formElement.minValue !== undefined ? formElement.minValue : 0}
                                                                maxValue={formElement.maxValue !== undefined ? formElement.maxValue : 999999999}
                                                                label={formElement.elementConfig.label}
                                                                invalid={!formElement.valid}
                                                                isFieldValid={formElement.fieldValid}
                                                                shouldValidate={formElement.validation}
                                                                commaSeparetedFunc={(emailArr) => this.commaSeparetedFunc(id, emailArr)}
                                                                changeErrorMessage={(errorMsg) => this.changeErrorMessage(id, errorMsg)}
                                                                changed={(event) => this.propsChanged(event, id)}
                                                                submitted={this.state.submitted}
                                                                error={formElement.validation.message}
                                                                fieldError={formElement.fieldValidation ? formElement.fieldValidation.message : ""}
                                                                required={formElement.validation.required}
                                                                data={formElement.elementConfig}
                                                                selects={this.props.selects}
                                                                selected={formElement.selected}
                                                                selectKey={this.props.selectKey}
                                                                formElement={formElement}
                                                                disableButtonFunc={(bool) => this.disableButtonFunc(bool)}
                                                                textBelowInput={formElement.textBelowInput !== undefined ? formElement.textBelowInput : ''}
                                                                hardCodeSelects={this.props.hardCodeSelects}
                                                                options={formElement.elementConfig.options}
                                                            />
                                                        )
                                                    } else {
                                                        if (formElement.type === 'desc') {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-4"></div>
                                                                    <div className="col-8" style={{ padding: 0 }}>
                                                                        <p>{this.state.paragraphText}</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-4"></div>
                                                                    <div className="col-8" style={{ padding: 0 }}>
                                                                        <p>{this.state.emailBroke}</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    }
                                                }
                                            )
                                        }
                                        <p style={{ position: 'absolute', right: 20, fontSize: 10, marginTop: -10 }}>{this.props.cautionText}</p>
                                    </div>

                                    :
                                    <div >

                                        {
                                            !this.props.checkboxModal.vviSelected &&
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-arround' }}>
                                                    <p style={{ textAlign: 'center', width: '100%' }}>{this.props.checkboxModal.heading}</p>
                                                    {
                                                        dataCheckbox.length !== 0 &&
                                                        <div style={{ display: 'flex', width: '100%' }}>
                                                            {
                                                                this.props.checkboxModal.selectAll !== false &&
                                                                <Button onClick={() => this.selectAllChecks(dataCheckbox)} type="button" style={{ fontSize: 14, margin: '0 10px 10px 10px' }}>Select All</Button>
                                                            }
                                                            {
                                                                this.props.checkboxModal.deselectAll !== false &&
                                                                <Button onClick={() => this.deSelectAllChecks(dataCheckbox)} type="button" style={{ fontSize: 14, margin: '0 10px 10px 10px' }}>De-Select All</Button>
                                                            }
                                                        </div>
                                                    }
                                                </div>


                                                <div style={checkboxStyle}>

                                                    {

                                                        dataCheckbox.map(val => {

                                                            let inpName = `modal${val.id}`

                                                            const labelStyle = this.props.heading === "SET CUSTOM REPORT ACCESS"
                                                                ? { cursor: 'pointer', whiteSpace: 'nowrap' }
                                                                : { cursor: 'pointer' };




                                                            return (
                                                                <div key={val.id} className="col-3 custom-checkbox custom-control custom-control-inline" style={{ display: 'flex', width: '49%' }}>
                                                                    <input className="custom-control-input" type="checkbox" name={inpName} id={inpName} checked={this.state.checkedItems.get(inpName)} onChange={(e) => this.handleChange(e, val)} />
                                                                    <label style={labelStyle} className="custom-control-label" for={inpName}>{val[this.props.checkboxModal.labelKey]}</label>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>


                                            </div>
                                        }

                                    </div>
                            }
                            {
                                this.props.vviSelected === true &&
                                <div className="text-center text-danger">
                                    Please Deselect VVI assessments
                                </div>
                            }
                            {
                                !this.props.metricDetails &&
                                this.props.tableModalText !== undefined &&
                                <div style={this.props.data.length === 0 ? { display: 'none' } : { paddingLeft: "2rem" }}>
                                    <div>
                                        <p>{this.props.tableModalText.topHeading}</p>
                                        <div style={{ padding: "0px 1rem 1rem", color: 'rgb(81, 81, 81)' }}>
                                            {this.props.tableModalText.topText}
                                        </div>
                                    </div>
                                    <hr />
                                    <div>
                                        <p>{this.props.tableModalText.bottomHeading}</p>
                                        <div style={{ padding: "0px 1rem 1rem", color: 'rgb(101, 101, 101)' }}>
                                            {this.props.tableModalText.bottomText}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div>
                                {
                                    this.props.bottomTable !== undefined &&
                                    this.props.bottomTable.type === 'MATRIX_FORM' &&
                                    <MatrixTable
                                        backFunc={this.props.backFunc}
                                        metricAction={(data) => this.getMetrixData(data)}
                                        matrixData={this.state.bottomTable.data}
                                        attributeList={this.state.bottomTable.attributeList}
                                    />
                                }
                                {
                                    this.props.singleButton === undefined && this.props.bottomTable === undefined &&
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {
                                            this.props.noReset !== undefined &&
                                            <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={() => this.resetValue()} type="button">RESET</Button>
                                        }
                                        {
                                            this.props.onlyBackButton ?
                                                <Button color="primary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.props.backFunc} type="button" >OK</Button>
                                                :
                                                <div>
                                                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.props.backFunc} type="button" >CANCEL</Button>
                                                    <Button color="primary" style={{ borderRadius: 0, margin: '0 10px' }} className="float-right" type="submit" disabled={this.props.creditModal ? this.state.disableButtonCredit : this.props.disableButton}>{this.props.triggerType}</Button>
                                                </div>
                                        }
                                    </div>
                                }

                                <div style={{ display: 'flex', justifyContent: 'center' }}>

                                    {
                                        this.props.singleButton !== undefined && this.props.onlyCancel === undefined ?
                                            <Button color="primary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.props.backFunc} type="button">{this.props.triggerType}</Button>
                                            :
                                            null

                                    }
                                </div>


                            </div>
                        </Form>
                        :
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button color="primary" onClick={this.props.backFunc}>OK</Button>
                        </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loading, text, error, mainLoading } = state.modalStatus;

    return {
        error,
        loading,
        text,
        mainLoading,
        state
    };
}

const connectedForm = connect(mapStateToProps)(DynamicForm2);
export default withRouter(connectedForm); 


// WEBPACK FOOTER //
// ./src/_components/common/Form2/index.jsx